<input (input)="inputValueChanges($event)" />
<select (change)="selectValueChanges($event)">
  <option *ngFor="let o of options" [value]="o">{{ o }}</option>
</select>
